import { MD3LightTheme } from "react-native-paper";

export const breakpoints = {
	xxs: 400,
	xs: 450,
	sm: 840,
	md: 1024,
	lg: 1280,
};

export const buildFontConfig = (font: string) => ({
	...Object.entries(MD3LightTheme.fonts).reduce(
		(acc, [key, value]) => ({
			// biome-ignore lint/performance/noAccumulatingSpread:
			...acc,
			[key]: {
				...value,
				fontFamily: `${font}-regular`,
			},
		}),
		{},
	),
	labelSmall: {
		fontFamily: `${font}-regular`,
		fontSize: 11,
		fontWeight: "500" as const,
		letterSpacing: 0.5,
		lineHeight: 16,
	},
	labelMedium: {
		fontFamily: `${font}-semibold`,
		fontSize: 12,
		fontWeight: "500" as const,
		letterSpacing: 0.5,
		lineHeight: 16,
	},
	labelLarge: {
		fontFamily: `${font}-regular`,
		fontSize: 14,
		fontWeight: "500" as const,
		letterSpacing: 0.1,
		lineHeight: 20,
	},
	titleSmall: {
		fontFamily: `${font}-semibold`,
		fontSize: 14,
		fontWeight: "500" as const,
		letterSpacing: 0.1,
		lineHeight: 20,
	},
	titleMedium: {
		fontFamily: `${font}-semibold`,
		fontSize: 16,
		fontWeight: "500" as const,
		letterSpacing: 0.15,
		lineHeight: 24,
	},
	titleLarge: {
		fontFamily: `${font}-semibold`,
		fontSize: 22,
		fontWeight: "400" as const,
		letterSpacing: 0,
		lineHeight: 28,
	},
});

export const buildComponentOverrides = (
	appOverrides?: Record<string, unknown>,
) => ({
	...appOverrides,
	dialog: {
		marginVertical: 48,
		marginHorizontal: 56,
		maxWidth: 560,
		minWidth: 328,
		alignSelf: "center" as const,
	},
	snackbar: {
		maxWidth: 400,
	},
	navDrawer: {
		expanded: {
			width: 280,
		},
		collapsed: {
			width: 80,
		},
	},
});
